import { createI18n } from "vue-i18n";
import pluralRules from "./rules/pluralization";
import datetimeFormats from "./rules/datetime"

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import es from "./locales/es.json";

const SUPPORTED_LOCALES = ['en', 'ru', 'es'];

function detectLocale(): string {
	const stored = localStorage.getItem("user-locale");
	if (stored) return stored;

	const browserLang = navigator.language?.slice(0, 2)?.toLowerCase();
	if (browserLang && SUPPORTED_LOCALES.includes(browserLang)) return browserLang;

	return 'ru';
}

export default createI18n({
	locale: detectLocale(),
	fallbackLocale: import.meta.env.VITE_DEFAULT_LOCALE,
	globalInjection: true,
	legacy: false,
	messages: {
		en,
		ru,
		es
	},
	pluralRules,
	datetimeFormats
})
